import { CourseRolesPayloadType } from 'src/web/containers/InstitutionAdminSettings/types';
import { ResourceMethod, ResourceTypeCreator } from '../types';

export type BackgroundTaskResourceReadMethod = ResourceMethod;

export type BackgroundTaskResourceUpdateMethod = BackgroundTaskResourceReadMethod;

export type BackgroundTaskResourceLookupMethod = ResourceMethod;

export type BackgroundTaskResourceExecuteMethod = BackgroundTaskResourceUpdateMethod;

export type BackgroundTaskResource = ResourceTypeCreator<
  'backgroundTask',
  string,
  never,
  BackgroundTaskResourceReadMethod,
  BackgroundTaskResourceUpdateMethod,
  never,
  BackgroundTaskResourceLookupMethod,
  BackgroundTaskResourceUpdateMethod
>;

export enum BackgroundTaskEnum {
  ASSIGN_TEAM_MEMBER_TO_COURSE = 'assign_team_member_to_course',
  ASSIGN_PENDING_TEAM_MEMBER_TO_COURSE = 'assign_pending_team_member_to_course',

  ASSIGN_LEARNER_TO_COURSE = 'assign_learner_to_course',
  ASSIGN_PENDING_LEARNER_TO_COURSE = 'assign_pending_learner_to_course',

  ADD_TEAM_MEMBER_TO_INSTITUTION = 'add_team_member_to_institution',
  ADD_LEARNER_TO_INSTITUTION = 'add_learner_to_institution',
}

export enum BackgroundTaskStatus {
  NOT_STARTED = 'not_started',
  IN_PROGRESS = 'in_progress',
  COMPLETED = 'completed',
  FAILED = 'failed',
}

export type AssignToCourseTaskResult = {
  id: string;
  status: BackgroundTaskStatus;
  groupId: string;
  type:
    | BackgroundTaskEnum.ASSIGN_LEARNER_TO_COURSE
    | BackgroundTaskEnum.ASSIGN_TEAM_MEMBER_TO_COURSE
    | BackgroundTaskEnum.ASSIGN_PENDING_LEARNER_TO_COURSE
    | BackgroundTaskEnum.ASSIGN_PENDING_TEAM_MEMBER_TO_COURSE;
  params: {
    // eslint-disable-next-line camelcase
    course_roles: CourseRolesPayloadType;
    // eslint-disable-next-line camelcase
    total_assigned_users: number;
    // eslint-disable-next-line camelcase
    user_ids?: string[];
  };
  result?: {
    totalSuccess: number;
    successUserIds: string[];
    totalFailed: number;
    failedUsers: {
      [userId: string]: {
        path: string;
        error: string;
      }[];
    };
  };
};

export type AddToInstitutionTaskResult = {
  id: string;
  status: BackgroundTaskStatus;
  groupId: string;
  type:
    | BackgroundTaskEnum.ADD_LEARNER_TO_INSTITUTION
    | BackgroundTaskEnum.ADD_TEAM_MEMBER_TO_INSTITUTION;
  params: {
    invites: {
      email: string;
    }[];
  };
  result?: {
    success: boolean;
    autoEnrolledStudents: { email: string }[];
    alreadyEnrolledStudents: { email: string }[];
    pendingEnrolledEmails: string[];
    unprocessedEmails: string[];
  };
};

export interface BackgroundTaskResourceDeleteBackgroundTask
  extends BackgroundTaskResourceUpdateMethod {
  name: 'delete';
}
